import { useEffect, useState } from "react";
import axiosInstance from "../services/axiosComman";
import { GetRole } from "../utils/RolesandAccess";

function useFetchFullStandard() {
  const [standardList, setStandardList] = useState([]);
  const [standardFullList, setStandardFullList] = useState([]);
  const [isLoading, setLoading] = useState(false);
  function getAllStandard() {
    setLoading(true);
    axiosInstance
      .get(`/Standards/`)
      .then((res) => {
        let tempdata = res?.data?.data || [];
        let finalArr = [];
        let fullList = [];
        res?.data?.data &&
          tempdata.forEach((item) => {
            if (GetRole()) {
              let temp = {
                value: item?.id,
                label: item?.name,
              };
              finalArr.push(temp);
              fullList.push(item);
            } else {
              if (item?.isActive && item?.keyActivated) {
                let temp = {
                  value: item?.id,
                  label: item?.name,
                };
                finalArr.push(temp);
                fullList.push(item);
              }
            }
          });
        setStandardList(finalArr);
        setStandardFullList(fullList);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err.response?.data);
      });
  }

  useEffect(() => {
    getAllStandard();
  }, []);

  return { standardList, standardFullList, getAllStandard, isLoading };
}

export default useFetchFullStandard;
